import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-511b2b61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "readonly" }, "BenefitMe", -1))
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Flex = _resolveComponent("Flex")!
  const _component_Container = _resolveComponent("Container")!

  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _createVNode(_component_Container, { size: "large" }, {
          default: _withCtx(() => [
            _createVNode(_component_Flex, {
              alignItems: "center",
              wrap: "wrap"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: _ctx.data.Footer.Logo.Href
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Text, { class: "logo-wrapper" }, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        _createElementVNode("img", {
                          src: _ctx.backendUrl + _ctx.data.Footer.Logo.Image.data.attributes.url,
                          alt: ""
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_Flex, {
                  class: "text-wrapper",
                  wrap: "wrap"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Text, {
                      value: _ctx.data.Footer.Mail,
                      size: "xsmall"
                    }, null, 8, ["value"]),
                    _createVNode(_component_Text, {
                      value: _ctx.data.Footer.Address,
                      size: "xsmall"
                    }, null, 8, ["value"]),
                    _createVNode(_component_Text, {
                      value: _ctx.data.Footer.Copyright,
                      size: "xsmall"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}